import { createSlice } from '@reduxjs/toolkit';
import { fetchUserSubscriptions } from '../subscriptionApi';

const fetchUserSubscriptionsSlice = createSlice({
    name: 'subscription/fetchUserSubscriptions',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchProductList cases
            .addCase(fetchUserSubscriptions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserSubscriptions.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchUserSubscriptions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default fetchUserSubscriptionsSlice.reducer;
